package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import app.bloomey.web.modules.feedback.model.Feedback
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Composable
fun FeedbackItem(modifier: Modifier = Modifier, feedback: Feedback) {
    val sitePalette = ColorMode.current.toSitePalette()
    val router = rememberPageContext().router
    Column(modifier = modifier.position(Position.Relative)) {
        Row(
            modifier = Modifier
                .top(-(16).px)
                .maxWidth(100.percent)
                .wordBreak(WordBreak.BreakAll)
                .overflow(Overflow.Hidden)
                .position(Position.Absolute)
                .margin(left = 24.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                feedback.email,
                modifier = Modifier.background(sitePalette.nearBackground)
                    .fontSize(14.px)
                    .padding(topBottom = 6.px, leftRight = 8.px)
                    .borderRadius(20.px)
                    .margin(right = 20.px)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        router.navigateTo("mailto:${feedback.email}")
                    }
            )
            SpanText(
                feedback.reaction,
                modifier = Modifier.fontSize(20.px).background(sitePalette.background)
                    .size(30.px)
                    .minSize(30.px)
                    .borderRadius(50.percent)
                    .textAlign(TextAlign.Center)
                    .boxShadow(color = Colors.Black.toRgb().copy(alpha = 30), blurRadius = 12.px)
            )
        }

        Column(
            modifier = Modifier.fillMaxWidth()
                .border(style = LineStyle.Solid, width = 1.px)
                .borderRadius(8.px)
                .padding(leftRight = 24.px, top = 50.px, bottom = 16.px)
        ) {
            SpanText(
                feedback.message,
                modifier = Modifier.margin(bottom = 18.px)
            )
            SpanText(
                "12:00Pm, 7th November 2024",
                modifier = Modifier.color(sitePalette.onBackgroundLight).fontSize(14.px)
            )
        }
    }
}